import { Dispatch } from "redux";
import { IResponse, RACARequest } from "../../Request";
import { startLoading, endLoading } from "../../../store/slices/loadingSlice";
import requestMiddlewares from "../../requestMiddlewares";
import { setSession } from "../../../store/slices/sessionSlice";

export interface ISignUpRequest{
    code:string
    returnURL: string
    refreshToken: boolean
}

export default async function googleLoginRequest(
    dispatch:Dispatch,
    bodyParams:ISignUpRequest
): Promise<IResponse>{

    dispatch(startLoading())

    const request = new RACARequest('auth', 'googleLogin')
    .setData(bodyParams)

    const response =  await request.makeRequest()

    requestMiddlewares(dispatch, response)
    
    if (response.data) {
        dispatch(setSession(response.data))
    }

    dispatch(endLoading())

    return response

}